import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-dialog',
    templateUrl: './page-dialog.component.html',
    styleUrls: ['./page-dialog.component.scss']
})
export class PageDialogComponent implements OnInit {

    @Input()
    width : number = 560

    constructor() { }

    ngOnInit(): void {

    }

    getWidth() {
        return this.width + 'px'
    }

}
